import { Component } from '@angular/core';

@Component({
  selector: 'app-eval-wegestu',
  templateUrl: './eval-wegestu.component.html',
  styleUrls: ['./eval-wegestu.component.css']
})
export class EvalWegestuComponent {

}
